/**
 * @file コンポーネント フル動画ページ評価ボタン ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import { fnHandleApiErrors } from "~/src/functions/common";

// コンポーネントを返す
export const ButtonRate = (props) => {
    /**
     * 評価ボタンクリック時の処理
     */
    const fnOnClickButton = async () => {
        const api = "/api/Ratings/change";
        const token = document
            .getElementById("requestverificationtoken")
            .getAttribute("value");
        const options = {
            body: JSON.stringify({
                isRated: !props.isRate,
                operationId: window.atob(props.operationId),
            }),
            headers: {
                "Content-Type": "application/json",
                RequestVerificationToken: token,
            },
            method: "POST",
        };
        fetch(api, options)
            .then(fnHandleApiErrors)
            .then((response) => {
                // 成功時に評価状態と評価数を変更
                if (response.status === 200) {
                    const newRateCount = props.isRate
                        ? props.rateCount - 1
                        : props.rateCount + 1;
                    props.setRateCount(newRateCount);
                    props.setIsRate(!props.isRate);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    // Presenterに渡す
    return <Presenter {...props} fnOnClickButton={fnOnClickButton} />;
};
